import request from '@/utils/request'
export function convert(data) {
    return request({
        url: `/api/unit-converter/convert`,
        method: 'post',
        data
    })
}

